class ToggleItem extends HTMLElement {
    constructor() {
      super();
      this._toggle = this._toggle.bind(this);
      this.querySelector("div").style.height = this.classList.contains("actif")
        ? "auto"
        : "0px";
    }
  
    connectedCallback() {
      this.querySelector("h3, p").addEventListener("click", this._toggle);
    }
  
    disconnectedCallback() {
      this.querySelector("h3, p").removeEventListener("click", this._toggle);
    }
  
    _toggle() {
      const content = this.querySelector("div");
      this.classList.toggle("actif");
      const isActive = this.classList.contains("actif");
      content.style.height = !isActive ? "0px" : `${content.scrollHeight}px`;
    }
  }
customElements.define("toggle-item", ToggleItem);

function calcShipping() {
  document.querySelectorAll('#delivery-estimate').forEach(el => {
    const delay = parseInt(el.dataset.delay, 10);

    const today = new Date();
    const deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + delay);

    const dow = deliveryDate.getDay();
    if (dow === 6) {
      deliveryDate.setDate(deliveryDate.getDate() + 2);
    } else if (dow === 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

    const day     = deliveryDate.getDate();
    const month   = deliveryDate.toLocaleString('fr-FR', { month: 'long' });
    const weekday = deliveryDate.toLocaleString('fr-FR', { weekday: 'long' });

    const heading = el.textContent.trim();
    const message = `${weekday} ${day} ${month}`;

    el.innerHTML = `${heading} <span class="delivery-date p-medium fw-700">${message}</span>`;
  });
}

window.calcShipping = calcShipping;

document.addEventListener('DOMContentLoaded', calcShipping);
document.addEventListener('shopify:section:load', calcShipping);





// const CartAPI = {
//   async add({ variantId, quantity = 1, properties = null }) {
//     const body = {
//       items: [{
//         id: Number(variantId),
//         quantity: Number(quantity),
//         ...(properties ? { properties } : {})
//       }]
//     };

//     const res = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(body)
//     });

//     if (!res.ok) throw new Error('Add to cart failed');
//     return res.json();
//   },

//   async get() {
//     const res = await fetch('/cart.js');
//     return res.json();
//   }
// };

async function refreshCartCount() {
  try {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
    });
  } catch (e) {
    console.error('Failed to refresh cart count:', e);
  }
}

window.refreshCartCount = refreshCartCount;

document.addEventListener('DOMContentLoaded', refreshCartCount);
document.addEventListener('shopify:section:load', refreshCartCount);

(function hookCartRequests() {
  if (window.__cartCountHooked) return;
  window.__cartCountHooked = true;

  const isCartUrl = (url) =>
    typeof url === 'string' &&
    (url.includes('/cart/add') ||
     url.includes('/cart/change') ||
     url.includes('/cart/update') ||
     url.includes('/cart/clear'));

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await originalFetch.apply(this, args);

    try {
      const input = args[0];
      const url = typeof input === 'string' ? input : input?.url;

      if (isCartUrl(url)) {
        setTimeout(refreshCartCount, 50);
      }
    } catch (e) {}

    return res;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__isCartRequest = isCartUrl(url);
    return originalOpen.call(this, method, url, ...rest);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      if (this.__isCartRequest) setTimeout(refreshCartCount, 50);
    });
    return originalSend.apply(this, args);
  };
})();
